<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_3",
      next: "P_5",
      topic: "Taller ¿Qué es crédito? / ¡Estoy listo para cursar esta lección!",
      reactivos: [
        {
          descripcion: "No quiero quedarme sin dinero para pagar un crédito"
        },
        {
          descripcion:
            "Quisiera informarme más sobre cómo funciona y la mejor manera de utilizarlo."
        }
      ],
      selected: [],
      respuesta: "none",
      response: 0,
      correcta: 1,
      sent: false,
      feedback: false,
      dialog: false
    };
  },
  methods: {
    sendResult() {
      if (this.respuesta == this.correcta) {
        this.response = 1;
      }
      this.sent = true;
      eventBus.$emit("send_result", this.response);
    },

  },
  computed: {
    responseIsNone() {
      return {
        "btn-primary": this.respuesta != "none",
        "btn-secondary": this.respuesta == "none"
      };
    },
    checkResult() {
      return {
        done: this.response != "none",
        clear: this.response == "none"
      };
    }
  }
};
</script>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') Estás en: {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B') PREGUNTA 3 DE 5
            v-card-text.titulo24Reg
              | Cada vez más personas financian sus compras con créditos y, como consecuencia, disfrutan de los múltiples beneficios que ofrece.
            v-card-text.parrafoDestacadoB.text-center  Marca tu respuesta.
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | ¿Cuál es la razón principal por la que tú no contratarías uno?
              v-radio-group(v-model='respuesta')
                v-layout.ml-5(v-for='(reactivo, index) in reactivos', :key='index')
                  v-flex.iconos.text-xs-center.pt-3(xs1, align-center, align-content-center)
                    div(v-if='sent && (correcta == index || respuesta == index)')
                      v-icon(size='15px', color='green', v-if='sent && (correcta == index)') fas fa-check
                      v-icon(size='15px', color='red', v-if='sent && (correcta != index)') fas fa-times
                  v-flex.iconos.text-xs-right(xs1, align-content-center)
                    v-radio(hide-details, :value='index')
                  v-flex.label16tt_blue.text-left.pr-5(xs12, align-content-center)
                    div(style="display:inline;" v-html="reactivo.descripcion").pr-5.parrafoDestacadoB
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false')
                  v-btn.btn(color='secondary', v-bind:class='responseIsNone', :disabled="respuesta=='none'", @click='sendResult()')
                    | Enviar
                div(v-if='sent')
                  v-btn.btn(color='accent', style='z-index:2', @click.prevent='dialog=true')
                    | Retroalimentación
                  v-dialog(v-model='dialog', persistent, max-width='930px', content-class="dialog_over")
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card.pb-4
                          .pt-1.pr-2(v-if='sent && (respuesta==correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoOk.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Estás en el lugar indicado! 
                          .pt-1.pr-2(v-if='sent && (respuesta!=correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Hay una mejor respuesta...
                          v-card.px-5.questionCard(justify-center, flat)
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==0)')
                              v-card-text.dialog_text
                                | Mientras te administres bien y pagues a tiempo las cantidades pactadas, estarás libre de esa preocupación. 
                              v-card-text.dialog_text
                                | Además, ¿sabías que los créditos cuentan con elementos y respaldos que te ayudarán a administrarlos de la mejor manera? Opciones de pago, un contrato, apps…
                              v-card-text.dialog_text
                                | ¡Descúbrelos!
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==1)')
                              v-card-text.dialog_text
                                | Con las siguientes actividades, descubrirás qué es y cómo funciona un crédito. 
                              v-card-text.dialog_text
                                | Además, te hablaremos sobre los aliados que te ayudarán a sacarle el mayor provecho: las opciones de pago, un contrato, apps… ¡Descúbrelos! 
                          v-btn.btn.dialog_btn(color='accent', @click.prevent="nextPage(next)")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>
